export const TEAMMATES = [
  "buzz",
  "part",
  "buds",
  "pops",
  "stone",
  "dome",
  "mike",
] as const;

export type TeammateId = (typeof TEAMMATES)[number];

export interface TeammateVisual {
  id: TeammateId;
  portraitKey: string;
  headScale: number;
  offsetX: number;
  offsetY: number;
}

export const TEAMMATE_VISUALS: Record<TeammateId, TeammateVisual> = {
  buzz: visual("buzz", 1, 0, 0),
  part: visual("part", 0.98, 0, 0),
  buds: visual("buds", 1.04, 0, -1),
  pops: visual("pops", 1.04, 0, -1),
  stone: visual("stone", 1.02, 0, 0),
  dome: visual("dome", 1, 0, 0),
  mike: visual("mike", 1.03, 1, 0),
};

export const TEAMMATE_LABEL: Record<TeammateId, string> = Object.fromEntries(
  TEAMMATES.map((id) => [id, "TEAMMATE"]),
) as Record<TeammateId, string>;

function visual(
  id: TeammateId,
  headScale: number,
  offsetX: number,
  offsetY: number,
): TeammateVisual {
  return {
    id,
    portraitKey: `portrait-${id}`,
    headScale,
    offsetX,
    offsetY,
  };
}

/** Matt ("part") is the hero, so he never shows up as an enemy. */
export const ENEMY_TEAMMATES: readonly TeammateId[] = TEAMMATES.filter(
  (id) => id !== "part",
);

export function pickTeammate(random: () => number = Math.random): TeammateId {
  const index = Math.floor(random() * ENEMY_TEAMMATES.length);
  return ENEMY_TEAMMATES[index] ?? "buzz";
}

export function walkerKey(_id: TeammateId, frame: 1 | 2 | "flat"): string {
  return frame === "flat" ? "enemy-walker-flat" : `enemy-walker-${frame}`;
}

export function troopaKey(_id: TeammateId, frame: 1 | 2 | "shell"): string {
  return frame === "shell" ? "enemy-shell" : `enemy-troopa-${frame}`;
}

export function plantKey(_id: TeammateId, frame: 1 | 2): string {
  return `enemy-plant-${frame}`;
}

export function bossKey(_id: TeammateId): string {
  return "enemy-boss";
}
